import React, { ReactElement, ReactNode } from 'react'
import { Svg } from 'ui'
import starIcon from 'images/organization/homepage/commonImages/star-3px.svg'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'

export const bigStarStyles = {
  width: '2.4rem',
  height: '2.4rem',
}

export default function StarsWrapper({
  children,
  starsSx,
  sx,
}: {
  starsSx: ThemeUIStyleObject[]
  sx?: ThemeUIStyleObject
  children?: ReactNode
}): ReactElement {
  const isDesktop = useBreakpointIndex() === 2

  return (
    <Flex
      data-testid="stars"
      sx={{
        position: 'relative',
        justifyContent: 'center',
        ...sx,
      }}
    >
      {children}
      {isDesktop && <Stars starsSx={starsSx} />}
    </Flex>
  )
}

function Stars({ starsSx }: { starsSx: ThemeUIStyleObject[] }) {
  return (
    <>
      {starsSx.map(starSx => (
        <Svg
          key={Object.entries(starSx).toString()}
          svg={starIcon}
          descriptiveText="Decorative star"
          sx={{
            position: 'absolute',
            display: ['none', 'none', 'block'],
            ...starSx,
          }}
        />
      ))}
    </>
  )
}
